<!-- modal-header -->
<div class="modal-header bg-primary text-white details-modal-header">
  <h5 class="modal-title text-white details-modal-title">{{ title }}</h5>

  <div>
    <!-- <i class="fa fa-envelope"  (click)="openMultipleMessageModal('Send Message', userInfo, true)" style="cursor:pointer;"></i> -->


    <button
      type="button"
      class="fs-6 btn-close btn-close-white"
      aria-label="Close"
      (click)="activeModal.dismiss('Cross click')"
    ></button>
  </div>
</div>

<!-- modal-body -->
<div class="modal-body details-modal-body">
  <div class="card shadow-sm">
    <!-- Header Section -->
    @if (userInfo ) {
      <div>
        @if (suspectData == null) {
          <div
            class="d-flex justify-content-between align-items-center px-3 py-2 bg-primary text-white"
            >
            <span> {{ userInfo.name }}</span>
            <div class="d-flex justify-content-between gap-4">
              <!-- Zoom -->
              <i
                class="fa fa-crosshairs"
                (click)="fetchProfilesFromOrganization(userInfo, $event, false)"
                title="zoom">
              </i>
              <!-- Phone -->
              @if (hasMobilePhone(userInfo)) {
                <i
                  class="fa fa-phone"
                  (click)="openPhoneWindow($event, userInfo)"
                  title="phone">
                </i>
              }
              @if (!hasMobilePhone(userInfo)) {
                <i
                  class="fa fa-phone"
                  style="opacity: 0.25"
                  title="no enabled">
                </i>
              }
              <!-- Email -->
              <i
                class="fa fa-envelope"
                (click)="openMultipleMessageModal('Send Message', userInfo, true)"
                title="send mail">
              </i>
              <!-- Messaging -->
              @if (hasMobilePhone(userInfo)) {
                <i
                  class="fa fa-commenting"
                  (click)="openChatWindow('SMS', userInfo, true)"
                  title="messaging">
                </i>
              }
              @if (!hasMobilePhone(userInfo)) {
                <i
                  class="fa fa-commenting"
                  style="opacity: 0.25"
                  title="no mobile phone">
                </i>
              }
            </div>
          </div>
        }
        <!-- Bootstrap Tabs -->
        <ul class="nav nav-tabs px-2 py-2 userdetail-custom-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              [class.active]="selectedTab === 'basic'"
              (click)="selectedTab = 'basic'"
              type="button"
              >
              Basic Information
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              [class.active]="selectedTab === 'photo'"
              (click)="selectedTab = 'photo'"
              type="button"
              >
              Photo
            </button>
          </li>
          @if (suspectData == null) {
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                [class.active]="selectedTab === 'emergency'"
                (click)="selectedTab = 'emergency'"
                type="button"
                >
                Emergency Contact
              </button>
            </li>
          }
          @if (suspectData == null) {
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                [class.active]="selectedTab === 'medical'"
                (click)="selectedTab = 'medical'"
                type="button"
                >
                Medical
              </button>
            </li>
          }
          @if (suspectData != null) {
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                [class.active]="selectedTab === 'LastFiveActivity'"
                (click)="selectedTab = 'LastFiveActivity'"
                type="button"
                >
                Last 5 Activity
              </button>
            </li>
          }
        </ul>
        <!-- Tab Content -->
        <div class="tab-content p-2 bg-light">
          <!-- Basic Info -->
          @if (selectedTab === 'basic') {
            <div>
              <p class="modal_p"><strong>Name :</strong> {{ userInfo.name }}</p>
              @if (suspectData == null) {
                <p class="modal_p">
                  <strong>Organization :</strong>
                  {{ userInfo.UserOrganizations?.length > 0 ? userInfo.UserOrganizations[0]?.Organization?.name : 'N/A' }}
                </p>
              }
              <p class="modal_p">
                <strong>Email :</strong>
                {{ (userInfo.UserEmails && userInfo.UserEmails.length > 0) ? userInfo.UserEmails[0].address : "N/A" }}
              </p>
              <p class="modal_p">
                <strong>Phone :</strong>
                @if (userInfo.UserPhones && userInfo.UserPhones.length > 0) {
                  @for (phone of userInfo.UserPhones; track phone; let i = $index) {
                    <span>
                      {{ phone.number }}
                      @if (phone.extension) {
                        <span>ext:{{ phone.extension }}</span>
                      }
                      @if (phone.carrier || phone.type || phone.purpose) {
                        <span>
                          ({{ phone.carrier || '' }}{{ phone.carrier && phone.type ? ' - ' : '' }}{{ phone.type || '' }}{{ (phone.carrier || phone.type) && phone.purpose ? ' - ' : '' }}{{ phone.purpose || '' }})
                        </span>
                      }
                      @if (i < userInfo.UserPhones.length - 1) {
                        <span><br></span>
                      }
                    </span>
                  }
                } @else {
                  N/A
                }
              </p>
              @if (suspectData == null) {
                <p  class="modal_p">
                  <strong>Address :</strong>
                  {{ (userInfo.UserAddresses && userInfo.UserAddresses.length > 0) ? userInfo.UserAddresses[0].address : "N/A" }}
                </p>
              }
            </div>
          }
          <!-- Photo -->
          @if (selectedTab === 'photo') {
            <div>
              <p class="modal_p"><strong>Photo :</strong></p>
              @if (userInfo.picture) {
                <img
                  [src]="userInfo.picture"
                  alt="User Photo"
                  style="max-width: 120px; max-height: 120px; border-radius: 50%"
                  />
              } @else {
                <p class="modal_p">No photo available</p>
              }
            </div>
          }
          <!-- Emergency Contact -->
          @if (selectedTab === 'emergency') {
            <div>
              <p class="modal_p"><strong> Emergency Contact :</strong></p>
              @if (userInfo.emergencyNumber) {
                <p>
                  {{ userInfo.emergencyNumber }}
                </p>
              } @else {
                <p class="modal_p">No available</p>
              }
            </div>
          }
          <!-- Medical Info -->
          @if (selectedTab === 'medical') {
            <div>
              <p class="modal_p"><strong> Medical :</strong></p>
              <p class="modal_p">No available</p>
            </div>
          }
          @if (selectedTab === 'LastFiveActivity') {
            <div>
              <table class="table table-sm mt-2 custom-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Activity</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  @for (act of activityList.slice(0, 5); track act; let i = $index) {
                    <tr>
                      <td class="text-dark">{{ i + 1 }}</td>
                      <td class="text-dark">{{ act.activity }}</td>
                      <td class="text-dark">{{ act.created_at | date : "dd/MM/yyyy" }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      </div>
    }
    @if (org) {
      <div>
        <p class="modal_p"><strong>Organization:</strong> {{ org.name }}</p>
      </div>
    }

    <!-- <div *ngIf="message">
    <p class="modal_p">{{message}}</p>
  </div> -->
</div>
@if (message) {
  <div class="text-center text-muted py-1">
    <p class="modal_p">{{ message }}</p>
  </div>
}
<!-- Fallback -->
</div>
